import React from 'react'

export default class extends React.Component {
  constructor (props) {
    super(props)
  }

  render () {
    return (<div>Menu Ajout</div>)
  }
}




// WEBPACK FOOTER //
// ./app/App/Module/Menu/Page/Ajout/index.js